<div *ngIf="subcategories && subcategories.length > 0" class="dropdown mobile_dropdown">
  <a href="javascript:void(0);" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" class="dropdown__title"><span class="category_label">{{subcategories[0]?.title}}<strong>{{subcategories[0]?.count}}</strong></span></a>
  <div class="dropdown-menu">
    <ul class="category_list mb-lg-4">
      <li *ngFor="let item of subcategories"  class="dropdown_item"><a *ngIf="item.count > 0" routerLink="{{'/catalog/' + item.alias}}" class="category_label">{{item.title}}<strong>{{item.count}}</strong></a></li>
    </ul>
  </div>
</div>
